import { render } from "./linkList.vue?vue&type=template&id=488b4cdc&scoped=true"
import script from "./linkList.vue?vue&type=script&lang=js"
export * from "./linkList.vue?vue&type=script&lang=js"

import "./linkList.vue?vue&type=style&index=0&id=488b4cdc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-488b4cdc"]])

export default __exports__